import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'xp-fields-collection-headers',
  template: ` <ng-content></ng-content> `,
  providers: [],
})
export class XpFieldsCollectionHeadersComponent {
  @Input() value: string;
  @Output() change = new EventEmitter();
}
